import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { isEqual, get } from 'lodash';
import FileTransportXHR2 from './adapter/FileTransportXHR2';
import FileTransportIFrame from './adapter/FileTransportIFrame';
import ReactSparkProgressIndicator from '../ReactSparkProgressIndicator';
import AddToBody from '../../helpers/AddToBody';

class FileTransportProxy extends Component {
    static propTypes = {
        onProgress: PropTypes.func,
        onError: PropTypes.func,
        onUploadStart: PropTypes.func,
        onComplete: PropTypes.func,
        metadata: PropTypes.object,
        filter: PropTypes.string,
        multiple: PropTypes.bool,
        disabled: PropTypes.bool
    };
    static defaultProps = {
        onError: () => {},
        onProgress: () => {},
        onUploadStart: () => {},
        onComplete: () => {},
        metadata: {},
        filter: '.*',
        multiple: true,
        disabled: false
    };

    shouldFallback() {
        const xhr = new XMLHttpRequest();
        return !(xhr && 'upload' in xhr && 'onprogress' in xhr.upload) || !window.FormData;
    }

    constructor(props) {
        super(props);
        this.formRefs = [];
        this.state = {
            files: [],
            progress: 0,
            showProgress: false
        };
        this.errorHandler = this.errorHandler.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.completeHandler = this.completeHandler.bind(this);
        this.onUploadStart = this.onUploadStart.bind(this);
    }

    componentDidMount() {
        if (this.props.setRef && typeof this.props.setRef === 'function') this.props.setRef(this);
    }

    /*shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextState.files, this.state.files) || !!nextState.progress;
    }*/

    setImplementation(ref) {
        this.implementation = ref;
    }

    progressHandler(progress) {
        this.setState({
            progress: progress
        });
        if (this.props.onProgress) {
            this.props.onProgress(progress);
        }
    }

    onUploadStart() {
        this.setState({
            progress: 0,
            showProgress: true
        });
        this.props.onUploadStart && this.props.onUploadStart();
    }
    onSuccess(result) {
        this.props.onSuccess && this.props.onSuccess(result);
    }
    onOpen() {
        this.props.onOpen && this.props.onOpen();
    }

    completeHandler() {
        this.setState({
            showProgress: false
        });
        this.props.onComplete();
    }

    errorHandler(error) {
        this.props.onError(error);
    }

    renderProgress(indeterminate = false) {
        return (
            <div className={`asset-browser--modal spark-modal ${this.state.showProgress && 'active'}`}>
                <div className="spark-modal__scroll">
                    <div className="spark-modal__content col-xs-10 col-sm-6 col-lg-3">
                        <div className="spark-modal__body">
                            <div className="row">
                                <div
                                    style={{
                                        textAlign: 'center',
                                        justifyContent: 'center',
                                        display: 'flex'
                                    }}
                                    className="col-xs-12"
                                >
                                    <ReactSparkProgressIndicator
                                        indeterminate={indeterminate}
                                        progress={this.state.progress}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const implementation = this.shouldFallback() ? FileTransportIFrame : FileTransportXHR2;
        if (!this.shouldFallback()) {
            return (
                <div className="asset-uploader">
                    {this.renderProgress()}
                    <FileTransportXHR2
                        setImplementation={ref => this.setImplementation(ref)}
                        filter={this.props.filter}
                        files={this.state.files}
                        onProgress={progress => this.progressHandler(progress)}
                        onOpen={() => this.onOpen()}
                        onResetErrors={this.props.onResetErrors}
                        onRefresh={this.props.onRefresh}
                        onComplete={this.completeHandler}
                        onError={this.errorHandler}
                        onSuccess={this.onSuccess}
                        store={this.props.store}
                        onUploadStart={this.onUploadStart}
                        metadata={this.props.metadata}
                        disabled={this.props.disabled}
                        multiple={this.props.multiple}
                    >
                        {this.props.children}
                    </FileTransportXHR2>
                </div>
            );
        } else {
            return (
                <div className="asset-uploader">
                    {this.renderProgress(true)}
                    <FileTransportIFrame
                        setImplementation={ref => this.setImplementation(ref)}
                        filter={this.props.filter}
                        files={this.state.files}
                        onProgress={progress => this.progressHandler(progress)}
                        onComplete={this.completeHandler}
                        onError={this.errorHandler}
                        store={this.props.store}
                        onUploadStart={this.onUploadStart}
                    >
                        {this.props.children}
                    </FileTransportIFrame>
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level
    };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FileTransportProxy);



// WEBPACK FOOTER //
// ./src/components/widgets/FileTransportProxy/FileTransportProxy.js